import React from 'react';
import {
  Card, DataTable, Typography, Link, TagChip,
} from 'vindi-ds-components';

function statusCell(value) {
  return value === 'active' ? <TagChip kind='success' label='Ativo' /> : <TagChip kind='inactive' label='Inativo' />;
}

const nameColumn = {
  headerName: <Typography variant='subtitle1'>Planos associados</Typography>,
  field: 'name',
  width: 444,
  renderCell: ({ id, value }) => (value ? <Link href={`/admin/plans/${id}`}> {value} </Link> : <Typography variant='body2'>O produto não está associado a nenhum plano</Typography>),
};

const statusColumn = {
  headerName: ' ',
  field: 'status',
  width: 100,
  renderCell: ({ value }) => (value ? statusCell(value) : ''),
};

function checkEmptyState(plans) {
  return plans.length !== 0 ? plans : [{ id: 1 }];
}

function Plans({ plans }) {
  const handlePage = () => new Promise((resolve) => {
    const data = {
      rows: checkEmptyState(plans),
      length: plans.length,
    };
    resolve(data);
  });

  const columns = [nameColumn, statusColumn];

  return (
    <Card>
      <DataTable options={{ paging: false }} handlePages={() => handlePage()} columns={columns} />
    </Card>
  );
}

export default Plans;
